import { Button as LibButton, ButtonArgs } from '@user-portal/wikr-components';
import React, { FC } from 'react';

const Button: FC<ButtonArgs & { children?: React.ReactNode }> = ({
    onClick,
    backgroundColor,
    textColor,
    hoverColor,
    size,
    disabled,
    isLoading,
    withPulsating,
    children,
    rightIcon,
    centerIcon,
    dataLocator,
    borderRadius,
    className,
    mb,
    type,
}) => (
    <LibButton
        onClick={onClick}
        backgroundColor={backgroundColor}
        textColor={textColor}
        hoverColor={hoverColor}
        size={size}
        disabled={disabled}
        isLoading={isLoading}
        withPulsating={withPulsating}
        children={children}
        rightIcon={rightIcon}
        centerIcon={centerIcon}
        dataLocator={dataLocator}
        borderRadius={borderRadius}
        className={className}
        mb={mb}
        type={type}
    />
);

export { Button };
